import { NOTIFICATION } from "../Action";

const initialState = {
  count: {},
};

const NotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION.count:
      return {
        ...state,
        count: action.data,
      };
    default:
      return state;
  }
};

export default NotificationReducer;
